import { CreateEditView, CreateEditViewType } from '../../types';

const DEFAULT_SCENE = 'scheduling';
const MY_SCHEDULE_SCENE = 'my-schedule';
const SCHEDULE_STUDIO = `${DEFAULT_SCENE}-studio`;
const CREATE_SCHEDULE = `${SCHEDULE_STUDIO}:create-schedule`;
const EDIT_SCHEDULE = `${SCHEDULE_STUDIO}:edit-schedule`;
const VIEW_SCHEDULE = `${SCHEDULE_STUDIO}:view-schedule`;
const SCHEDULING_SCENE = `${CREATE_SCHEDULE}:composer`;
const PERSONS_SIDEBAR = `${SCHEDULING_SCENE}:persons-sidebar`;
const CONFIGURATION_SIDEBAR = `${SCHEDULE_STUDIO}:configuration-sidebar`;

export const getTag = (container: string) => (fieldName: string) => `${container}:input-${fieldName}`;

export const CANCEL_BUTTON = `cancel-button`;
export const NEXT_STEP_BUTTON = `next-step-button`;
export const SAVE_BUTTON = `save-button`;
export const PREVIOUS_STEP_BUTTON = `previous-step-button`;

export const getButtonTestId = (action: CreateEditViewType, page: number, button: string) => {
  let name = VIEW_SCHEDULE;

  if (action === CreateEditView.CREATE) {
    name = CREATE_SCHEDULE;
  }

  if (action === CreateEditView.EDIT) {
    name = EDIT_SCHEDULE;
  }

  return `${name}(${page}):${button}`;
};

// ScheduleStudio
export const CONTAINER_TAG = `${SCHEDULE_STUDIO}:container`;
export const CREATE_SCHEDULE_BUTTON_TAG = `${SCHEDULE_STUDIO}:button-create`;
export const STUDIO_TITLE_TAG = `${SCHEDULE_STUDIO}:title`;
export const LIST_OF_SCHEDULES_CONTAINER_TAG = `${SCHEDULE_STUDIO}:container`;
export const getListOfSchedulesHeaderTag = (headerName: string) => `${SCHEDULE_STUDIO}:header-${headerName}`;
export const getSchedulePropTag = (order: number, propName: string) =>
  `${SCHEDULE_STUDIO}:schedule[${order}]-${propName}`;

// SchedulingComposer
export const CREATE_SCHEDULE_FORM_TAG = `${SCHEDULING_SCENE}:create-form`;
export const EDIT_SCHEDULE_FORM_TAG = `${SCHEDULING_SCENE}:edit-form`;
export const VIEW_SCHEDULE_FORM_TAG = `${SCHEDULING_SCENE}:view-form`;
export const DELETE_ELEMENT_SUBMIT_BUTTON_TAG = `${SCHEDULING_SCENE}:button-delete-element`;
export const PREVIOUS_DAY_BUTTON_TAG = `${SCHEDULING_SCENE}:button-previous-day`;
export const NEXT_DAY_BUTTON_TAG = `${SCHEDULING_SCENE}:button-next-day`;
export const CURRENT_DATE_BUTTON_TAG = `${SCHEDULING_SCENE}:button-current-date`;
export const UNDO_SCHEDULE_BUTTON_TAG = `${SCHEDULING_SCENE}:button-undo-action`;
export const REDO_SCHEDULE_BUTTON_TAG = `${SCHEDULING_SCENE}:button-redo-action`;
export const AGENTS_CONTEXT_MENU = `${SCHEDULING_SCENE}:agents-context-menu`;
export const TRIGGER_AGENT_AUTO_SCHEDULE_BUTTON_TAG = `${SCHEDULING_SCENE}:button-trigger-agent-auto-schedule-job`;
export const COPY_AGENT_SCHEDULE_BUTTON_TAG = `${SCHEDULING_SCENE}:button-copy-agent-schedule`;
export const PASTE_AGENT_SCHEDULE_BUTTON_TAG = `${SCHEDULING_SCENE}:button-paste-agent-schedule`;
export const CLEAR_AGENT_SCHEDULE_BUTTON_TAG = `${SCHEDULING_SCENE}:button-clear-agent-schedule`;
export const SELECT_ALL_AGENT_SCHEDULE_BUTTON_TAG = `${SCHEDULING_SCENE}:button-select-all-agent-schedule`;
export const CLONE_AGENT_SCHEDULE_BUTTON_TAG = `${SCHEDULING_SCENE}:button-clone-agent-schedule`;
export const CANCEL_CLONE_MENU_BUTTON_TAG = `${SCHEDULING_SCENE}:button-cancel-clone-agent-schedule-menu`;
export const CONFIRM_CLONE_MENU_BUTTON_TAG = `${SCHEDULING_SCENE}:button-confirm-clone-agent-schedule-menu`;
export const SCHEDULING_DATE_PICKER_INPUT_TAG = `${SCHEDULING_SCENE}:input-datepicker`;
export const EXPORT_SCHEDULE = `${SCHEDULING_SCENE}:export-schedule`;
export const EXPORT_SCHEDULE_DROPDOWN_TOGGLE = `${EXPORT_SCHEDULE}:dropdown-toggle`;
export const EXPORT_SCHEDULE_ONE_DAY = `${EXPORT_SCHEDULE}:one-day-export`;
export const EXPORT_SCHEDULE_FULL = `${EXPORT_SCHEDULE}:full-schedule-export`;
export const SETTINGS = `${SCHEDULING_SCENE}:settings`;
export const SETTINGS_DROPDOWN_TOGGLE = `${SETTINGS}:dropdown-toggle`;
export const SETTINGS_TOGGLE_AGENTS = `${SETTINGS}:toggle-agents`;
export const SETTINGS_SHOW_ALL_AGENTS = `${SETTINGS}:show-all-agents`;
export const SETTINGS_CLONE_ALL_SCHEDULE = `${SETTINGS}:clone-all-schedule`;

export const SCHEDULE_JOB_RUNNING_TOAST_ID = 'scheduleJobRunningInfo';

export const PIN_ACTIVITIES_SUBMENU = 'pin-activities-submenu';
export const PIN_SELECTED_ACTIVITIES = 'pin-selected-activities';
export const PIN_ALL_ACTIVITIES_IN_GIVEN_DAY = 'pin-all-activities-in-given-day';
export const PIN_ALL_ACTIVITIES = 'pin-all-activities';
export const UNPIN_ACTIVITIES_SUBMENU = 'unpin-activities-submenu';
export const UNPIN_SELECTED_ACTIVITIES = 'unpin-selected-activities';
export const UNPIN_ALL_ACTIVITIES_IN_GIVEN_DAY = 'unpin-all-activities-in-given-day';
export const UNPIN_ALL_ACTIVITIES = 'unpin-all-activities';

export const getHoursPerAgentButtonTag = (order: number) => `${SCHEDULING_SCENE}:button-hours-per-agent[${order}]`;
export const getYLabelTag = (order: number) => `${SCHEDULING_SCENE}:y-label[${order}]`;
export const getScheduledHoursTag = (order: number, propName: string) =>
  `${SCHEDULING_SCENE}:hours-per-agent[${order}]-${propName}`;

export const getElementPropTag = (order: number, propName: string) =>
  `${SCHEDULING_SCENE}:element[${order}]-${propName}`;

// Persons SideBar
export const ADD_PERSONS_BUTTON_TAG = `${PERSONS_SIDEBAR}:button-toggle-add-persons-sidebar`;
export const ADD_PERSONS_SUBMIT_BUTTON_TAG = `${PERSONS_SIDEBAR}:button-add-agent`;
export const ADD_PERSONS_CANCEL_BUTTON_TAG = `${PERSONS_SIDEBAR}:button-cancel-add-agent`;
export const SHOW_ACTIVE_FILTERS_BUTTON_TAG = `${PERSONS_SIDEBAR}:button-show-active-filters`;
export const RESET_ALL_FILTERS_BUTTON_TAG = `${PERSONS_SIDEBAR}:reset_all_filters`;
export const PERSONS_BULK_ASSIGN_SEARCH = `${PERSONS_SIDEBAR}:input-search-persons`;
export const SELECT_ALL_SUITED_PERSONS_CHECKBOX = `${PERSONS_SIDEBAR}:checkbox-select-all-suited-persons`;
export const UNSELECT_ALL_SELECTED_PERSONS_CHECKBOX = `${PERSONS_SIDEBAR}:checkbox-unselect-all-persons`;
export const PERSONS_SIDEBAR_DROPDOWN_TOGGLE = `${PERSONS_SIDEBAR}:dropdown-toggle`;
export const SUITED_PERSONS_RESULT = `${PERSONS_SIDEBAR}:suited-persons-count`;

export const getAgentDetailButtonTag = (agentId: string) => `${PERSONS_SIDEBAR}:button-agent-detail-[${agentId}]`;
export const getAgentsDetailTag = (agentId: string, type: string) =>
  `${PERSONS_SIDEBAR}:agents-detail-[${agentId}]:[${type}]`;

export const getSuitedAgentCheckboxTag = (agentId: string) => `${PERSONS_SIDEBAR}:checkbox-suited-agent-[${agentId}]`;
export const getAssignedSuitedAgentCheckboxTag = (agentId: string) =>
  `${PERSONS_SIDEBAR}:checkbox-assigned-suited-agent-[${agentId}]`;
export const getAssignedUnSuitedAgentCheckboxTag = (agentId: string) =>
  `${PERSONS_SIDEBAR}:checkbox-assigned-unsuited-agent-[${agentId}]`;

// Auto-Schedule Configuration SideBar
export const TOGGLE_CONFIGURATION_BUTTON_TAG = `${CONFIGURATION_SIDEBAR}:button-toggle-schedule-configuration-sidebar`;
export const RESET_ALL_CONFIGURATIONS_BUTTON_TAG = `${CONFIGURATION_SIDEBAR}:reset-all-configurations`;
export const getRangePropTag = (propName: string) => `${CONFIGURATION_SIDEBAR}:range-selector-${propName}`;
export const getPrioritizeSelectorPropTag = (propName: string, type: 'label' | 'input') =>
  `${CONFIGURATION_SIDEBAR}:prioritize-selector-${propName}:${type}`;

// CreateSchedule
export const CREATE_TITLE_TAG = `${CREATE_SCHEDULE}:title`;
export const CREATE_SCHEDULING_CONTAINER_TAG = `${CREATE_SCHEDULE}:container`;
export const getDateRangeInputTag = getTag(CREATE_SCHEDULE);
export const DELETE_AGENT_BUTTON_TAG = `${SCHEDULING_SCENE}:button-delete-agent`;

// Agent Workplace
const AGENT_WORKPLACE = `${SCHEDULING_SCENE}:agent-workplace`;
const AGENT_WORKPLACE_BUTTON = `${AGENT_WORKPLACE}:button`;
export const AGENT_WORKPLACE_ICON = `${AGENT_WORKPLACE}:icon`;
export const AGENT_WORKPLACE_REMOTE_BUTTON = `${AGENT_WORKPLACE_BUTTON}-remote`;
export const AGENT_WORKPLACE_OFFICE_BUTTON = `${AGENT_WORKPLACE_BUTTON}-office`;

// Calendar Export
const CALENDAR_EXPORT = `${MY_SCHEDULE_SCENE}:calendar-export`;
export const CALENDAR_EXPORT_TOGGLE_BUTTON = `${CALENDAR_EXPORT}:toggle:button`;
export const CALENDAR_EXPORT_COPY_BUTTON = `${CALENDAR_EXPORT}:copy:button`;
export const CALENDAR_EXPORT_CONTENT = `${CALENDAR_EXPORT}:content`;

// SideBar Filter
const FILTER_SIDEBAR = `${DEFAULT_SCENE}:filter-sidebar`;
export const TOGGLE_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-toggle`;
export const APPLY_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-apply`;
export const FILTER_SIDEBAR_DROPDOWN_TOGGLE = `${FILTER_SIDEBAR}:dropdown-toggle`;
export const RESET_ALL_SIDEBAR_FILTERS_BUTTON_TAG = `${FILTER_SIDEBAR}:reset-all-filters`;
export const ACTIVE_SIDEBAR_FILTERS_COUNTER = `${FILTER_SIDEBAR}:active-filters-counter`;
